import {SelectDrawerableFilterable as Root} from './component';
import {SubjectLevelFilter} from './components/subject-level-filter';
import {TeacherFilter} from './components/teacher-filter';

export const SelectDrawerableFilterable = Object.assign(Root, {
	SubjectLevelFilter,
	TeacherFilter,
});
